import Vue from 'vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import App from './App.vue'
import router from './router'
import store from './store'
import FloatingContactButtons from './components/chat/FloatingContactButtons.vue' // 悬浮按钮
import IconFont from './components/IconFont.vue' // iconfont组件
import '@/assets/iconfont/iconfont.css' // 引入本地iconfont样式

Vue.use(ElementUI)
Vue.config.productionTip = false
Vue.component('FloatingContactButtons', FloatingContactButtons)
Vue.component('IconFont', IconFont) // 全局注册iconfont组件

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app') 